import React from 'react';

const PositionsTable = ({
  selectAllRef,
  headerCountLabel,
  onSelectAll,
  orderPositions,
  selectedPositionIds,
  onTogglePosition,
  renderRowPosition,
}) => {
  return (
    <table className="table table-striped">
      <thead>
        <tr>
          <th>
            <input
              ref={selectAllRef}
              type="checkbox"
              className="form-check-input"
              onChange={onSelectAll}
            />
            <span className="ms-2">{headerCountLabel}</span>
          </th>
          <th>Номер заказа / Отправления / Дата</th>
          <th>Картинка</th>
          <th>Название / Артикул</th>
          <th>Цена</th>
        </tr>
      </thead>
      <tbody>
        {(orderPositions || []).map((p, i) => renderRowPosition(p, i, selectedPositionIds, onTogglePosition))}
      </tbody>
    </table>
  );
};

export default PositionsTable;
